export const PRESETS = ['2h', '4h', '6h', '12h', '24h'];
export function presetToCron(p) {
    switch (p) {
        case '2h':
            return '0 */2 * * *';
        case '4h':
            return '0 */4 * * *';
        case '6h':
            return '0 */6 * * *';
        case '12h':
            return '0 */12 * * *';
        case '24h':
            return '0 0 * * *';
    }
}
export function cronToPreset(cron) {
    for (const p of PRESETS)
        if (presetToCron(p) === cron.trim())
            return p;
    return 'custom';
}
export function describeCron(cron) {
    const p = cronToPreset(cron);
    if (p === '24h')
        return 'Every day at 00:00 UTC';
    if (p !== 'custom')
        return `Every ${p.replace('h', ' hours')}`;
    return cron;
}
/**
 * Best-effort next-N-runs label for the presets we support in the UI.
 * Falls back to echoing the cron string for any non-preset expression.
 */
export function nextRunsLabel(cron, fromMs = Date.now(), count = 3) {
    const p = cronToPreset(cron);
    if (p === 'custom')
        return cron;
    const stepH = p === '24h' ? 24 : Number(p.replace('h', ''));
    const stepMs = stepH * 3600 * 1000;
    const fromHour = new Date(fromMs);
    fromHour.setUTCMinutes(0, 0, 0);
    let t = fromHour.getTime();
    while (t <= fromMs)
        t += stepMs;
    const out = [];
    for (let i = 0; i < count; i++) {
        const d = new Date(t);
        out.push(`${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}`);
        t += stepMs;
    }
    return `${out.join(' · ')} UTC`;
}
